<template>
  <div class="album">
    <div v-if="isPC" class="flash-sale">
      <div class="flash-sale-nav" v-if="groupsData.bannerImgUrl">
        <oss-img :src="groupsData.bannerImgUrl" :width="702" :height="427" style="width:100%;border-radius: 12px;" />
      </div>
      <div v-if="+groupsData.level === 2" class="sellTab f-b-c">
        <el-tabs ref="sellTab" v-model="activeTab" @tab-click="changeGroup" style="width: 94%">
          <el-tab-pane v-for="item in groupsList" :key="item.groupId||item.groupName" :label="item.groupName" :name="item.groupId||item.groupName" />
        </el-tabs>
        <!-- <el-dropdown trigger="click" @command="handleCommand">
          <div class="f--c">
            <i class="iconfont icon-menu-fill"/>
            <div style="margin-left:6px">{{ $t('Index.Album.Components.TemplateOne.All') }}</div>
          </div>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item v-for="item in groupsList" :key="item.groupId||item.groupName" :command="item.groupId||item.groupName">{{ item.groupName }}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown> -->
      </div>
      <div class="product-filter f-e-c" :style="{ marginTop: groupsData.bannerImgUrl?'0':'20px' }">
        <el-dropdown trigger="click" @command="handleCommand">
          <div class="f--c">
            <i class="iconfont icon-menu-fill"/>
            <div style="margin-left:6px">{{ $t('Index.Album.Components.TemplateOne.All') }}</div>
          </div>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item v-for="item in groupsList" :key="item.groupId||item.groupName" :command="item.groupId||item.groupName">{{ item.groupName }}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <el-select v-if="!country" v-model="listParams.countryCodeArray" multiple collapse-tags :placeholder="$t('inSrock.shippingFrom')" class="shipping-from" @change="resetPage()">
          <el-option v-for="item in shippingFromList" :key="item.countryCode" :label="item.countryCn" :value="item.countryCode"></el-option>
        </el-select>
        <Sort ref="sortCompoent"  style="margin-left: 15px;" @change="sortChange"></Sort>
        <el-input placeholder="Search" v-model="searchName" style="width:360px;margin-left:15px" class="inputGroup">
          <template slot="append">
            <el-button icon="el-icon-search" type="success" @click="searchHandle"></el-button>
          </template>
        </el-input>
      </div>
      <div class="product-list f fw-w " v-loading="listLoading">
        <Product v-for="item in saleProductList" :key="item.kkProductId" :product="item" :currentWarehouse="country || ''" :noChangeWarehouse="country && true" class="product-item" kklocation="albumList" reportType="album"></Product>
      </div>
      <div v-if="noProductShow" class="empty">
        <div class="f-c-c fd-c">
          <img src="@/assets/img/activity_empty.svg" alt="">
          <p>{{ $t('Index.Album.Components.TemplateOne.NoProductFound') }}</p>
        </div>
      </div>
      <el-button v-if="showMore" class="more f-c-c pointer" :loading="listLoading" @click="handleMore">
        <div>{{ $t('Index.Album.Components.TemplateOne.ViewMore') }}</div>
        <i class="iconfont icon-jiantou-xuanze" />
      </el-button>
    </div>
    <div v-else class="mobile-flash">
      <el-tabs v-if="+groupsData.level === 2" ref="sellTab" v-model="activeTab" class="sellTab" @tab-click="changeGroup">
        <el-tab-pane v-for="item in groupsList" :key="item.groupId" :label="item.groupName" :name="item.groupId" />
      </el-tabs>
      <div :class="[fixFilter?'fix-filter':'']">
        <van-dropdown-menu>
          <van-dropdown-item v-model="mobileShipFrom" title="Ship From">
            <van-cell center :title="item.countryCn" v-for="item in shippingFromList" :class="[item.checked?'checked-country':'']" :key="item.countryCn" @click="shipFromChangeMobile(item)">
              <template #right-icon>
                <i class="el-icon-check" v-if="item.checked"></i>
              </template>
            </van-cell>
          </van-dropdown-item>
          <van-dropdown-item  v-model="sortKeyForMobile" :options="sortListForMobile" @change="value => sortChangeMobile(value)"></van-dropdown-item>
        </van-dropdown-menu>
      </div>
      <div class="product-list f-b-c fw-w " v-loading="listLoading">
        <Product v-for="item in saleProductList" :key="item.kkProductId" :product="item" :currentWarehouse="country || ''" :noChangeWarehouse="country && true" class="product-item" kklocation="albumList" reportType="album"></Product>
      </div>
      <div v-if="!saleProductList.length && !listLoading" class="empty">
        <div class="f-c-c fd-c">
          <img src="@/assets/img/activity_empty.svg" alt="">
          <p>{{ $t('Index.Album.Components.TemplateOne.NoProductFound') }}</p>
        </div>
      </div>
    </div>
    <el-backtop :bottom="190" :right="6" class="backtop">
      <img style="width:70px;height:70px" src="@/assets/img/homePage/backtop.png" alt="" />
    </el-backtop>
  </div>
</template>

<script>
import API from '@/api'
import Sort from '@/views/commodity/components/Sort.vue'
import Product from '@/components/Product.vue'
import DropdownMenu from 'vant/lib/dropdown-menu'
import 'vant/lib/dropdown-menu/style'
import DropdownItem from 'vant/lib/dropdown-item'
import 'vant/lib/dropdown-item/style'
import cell from 'vant/lib/cell'
import 'vant/lib/cell/style'
import 'vant/lib/icon/style'
import getSortOptions from '@/config/sortOptions.js'
import _ from 'lodash'
export default {
  components: {
    Sort,
    Product,
    'van-dropdown-menu': DropdownMenu,
    'van-dropdown-item': DropdownItem,
    'van-cell': cell
  },
  data() {
    return {
      listLoading: false,
      noProductShow: false,
      searchName: '',
      activeTab: '',
      listParams: {
        pageNumber: 1,
        pageSize: 40,
        groupId: undefined
      },
      fixFilter: false,
      filterVisible: false,
      filterState: '',
      total: 0,
      shippingFromList: [],
      mobileShipFrom: [],
      saleProductList: [],
      saleEndTime: '', // 截止时间
      totalPage: undefined,
      countryCodeArrayMobile: 'US',
      sortKeyForMobile: 1,
      groupsData: {},
      groupsList: [],
      activeName: 'Autumn-Winter',
      country: '' // 选择的国家仓库
    }
  },
  computed: {
    showMore() {
      return this.saleProductList.length < this.total
    },
    sortListForMobile() {
      const arr = getSortOptions.call(this)
      arr.forEach(e => {
        e.text = e.name
        e.value = e.key
      })
      return arr
    }
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener('scroll', this.scroll)
    })
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.scroll)
  },
  created() {
    this.getShippingFromList()
  },
  watch: {
    '$route.query.moduleId'(value) {
      this.$set(this.$data, 'listParams', {
        pageNumber: 1,
        pageSize: 40
      })
      this.$set(this.$data, 'searchName', undefined)
      if (this.isPC) {
        this.$refs.sortCompoent.sortreset()
      } else {
        this.$set(this.$data, 'mobileShipFrom', [])
        this.$set(this.$data, 'sortKeyForMobile', 1)
      }
      // this.getAlbumModuleGroup()
    },
    '$route.query.keywords'(value) {
      this.$set(this.$data, 'listParams', {
        pageNumber: 1,
        pageSize: 40
      })
      this.$set(this.$data, 'searchName', undefined)
      if (this.isPC) {
        this.$refs.sortCompoent.sortreset()
      } else {
        this.$set(this.$data, 'mobileShipFrom', [])
        this.$set(this.$data, 'sortKeyForMobile', 1)
      }
    }
  },
  methods: {
    // 初始化
    init(groupsData, moduleId) {
      this.moduleId = moduleId || this.$route.query.moduleId
      groupsData.groupsList = groupsData.groupsList.map(item => ({ ...item, groupId: item.groupId ? (item.groupId + '') : undefined }))
      this.groupsData = _.cloneDeep(groupsData)
      this.groupsList = groupsData.groupsList
      if (+this.groupsData.level === 2) {
        this.$set(this.listParams, 'groupId', this.groupsList[0].groupId || undefined)
        this.$set(this.listParams, 'groupName', this.groupsList[0].groupName || undefined)
        this.$set(this.$data, 'activeTab', this.groupsList[0].groupId || this.groupsList[0].groupName)
        this.$set(this.$data, 'country', this.groupsList[0].country)
      } else {
        this.$set(this.$data, 'country', this.groupsList[0].country)
      }
      this.getAlbumModuleList()
    },

    // 专辑分组
    // getAlbumModuleGroup() {
    //   API.getAlbumModuleGroup({ moduleId: this.$route.query.moduleId }).then(res => {
    //     res.data.groupsList = res.data.groupsList.map(item => ({ ...item, groupId: item.groupId ? (item.groupId + '') : undefined }))
    //     this.groupsData = _.cloneDeep(res.data)
    //     this.groupsList = res.data.groupsList
    //     if (+res.data.level === 2) {
    //       this.$set(this.listParams, 'groupId', this.groupsList[0].groupId || undefined)
    //       this.$set(this.listParams, 'groupName', this.groupsList[0].groupName || undefined)
    //       this.$set(this.$data, 'activeTab', this.groupsList[0].groupId || this.groupsList[0].groupName)
    //     }
    //     this.getAlbumModuleList()
    //   })
    // },

    // 专辑全部商品
    getAlbumModuleList() {
      this.noProductShow = false
      this.listParams.moduleId = this.moduleId || this.$route.query.moduleId
      if (!this.isPC) { this.listParams.countryCodeArray = this.getCountryCodeArray() }
      API.getAlbumModuleList(this.listParams).then(({ data }) => {
        this.saleProductList = this.listParams.pageNumber === 1 ? data.list : [...this.saleProductList, ...data.list]
        this.total = data.total
        this.totalPage = Math.ceil(this.total / this.listParams.pageSize)
        this.saleEndTime = data.list.length && data.list[0].endTime
        this.noProductShow = !(this.saleProductList.length > 0)
      }).finally(() => {
        this.listLoading = false
      })
    },

    // 搜索格式化
    searchHandle() {
      this.listParams.searchName = this.searchName ? this.searchName.split(',') : undefined
      this.resetPage()
    },
    // 下拉选择
    handleCommand(command) {
      this.groupsList.forEach(item => {
        if (item.groupId === command || item.groupName === command) {
          this.$set(this.listParams, 'groupId', item.groupId || undefined)
          this.$set(this.listParams, 'groupName', item.groupName || undefined)
          this.$set(this.$data, 'activeTab', item.groupId || item.groupName)
          this.$set(this.$data, 'country', item.country || undefined)
          this.resetPage()
        }
      })
    },

    changeGroup() {
      this.groupsList.forEach(item => {
        if (item.groupId === this.activeTab || item.groupName === this.activeTab) {
          this.$set(this.listParams, 'groupId', item.groupId || undefined)
          this.$set(this.listParams, 'groupName', item.groupName || undefined)
          this.$set(this.$data, 'country', item.country || undefined)
          this.resetPage()
        }
      })
    },

    scroll() {
      if (this.isPC) {
        return
      }
      let scrollTop = document.documentElement.scrollTop || document.body.scrollTop
      let windowHeight = document.documentElement.clientHeight || document.body.clientHeight
      let scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight
      if (scrollTop > 50) {
        this.fixFilter = true
      } else {
        this.fixFilter = false
      }
      if (scrollTop + windowHeight - scrollHeight > -200 && !this.listLoading && this.listParams.pageNumber < this.totalPage) {
        this.listParams.pageNumber++
        this.getAlbumModuleList()
      }
    },

    getShippingFromList() {
      API.getShippingFromList({
        pageSize: 100,
        pageNumber: 1
      }).then(result => {
        // 以国家编码去重
        const map = {}
        result.data.list.forEach(item => {
          if (['CN_N', 'CN_S'].includes(item.countryCode)) {
            map['CN'] = {
              countryCn: 'China',
              countryCode: 'CN'
            }
            return
          }
          map[item.countryCode] = {
            countryCn: item.countryCn,
            countryCode: item.countryCode
          }
        })
        this.shippingFromList = Object.values(map)
      })
    },

    resetPage(val) {
      this.listParams.pageNumber = val || 1
      this.getAlbumModuleList()
    },

    sortChange(sortName, sortType) {
      this.filterVisible = false
      this.listParams.sortName = sortName
      this.listParams.sortType = sortType
      this.resetPage()
    },

    handleMore() {
      if (!this.showMore) return
      ++this.listParams.pageNumber
      this.getAlbumModuleList()
    },

    shipFromChangeMobile(value) {
      this.$set(value, 'checked', !value.checked)
      this.resetPage()
    },
    getCountryCodeArray() {
      let countryCodeArray = this.shippingFromList.filter(e => e.checked).map(e => e.countryCode)
      return countryCodeArray.length ? countryCodeArray : undefined
    },
    sortChangeMobile(value) {
      const { sortName, sortType } = this.sortListForMobile.find(e => e.value === value)
      this.sortChange(sortName, sortType)
    }
  }
}
</script>

<style lang="scss" scoped>
.album-dropdown{
  height: 300px !important;
  overflow-y: auto !important;
}
.album {
  padding-bottom: 20px;
  .sellTab {
    background-color: #fff;
    padding: 8px 20px 1px 30px;
    margin-bottom: 10px;
    /deep/ .el-tabs__header{
      margin: 0;

      .el-tabs__nav-wrap::after{
        width: 0;
        height: 0;
      }
      .el-tabs__item {
        height: 46px;
        color: #999;
      }
      .el-tabs__item.is-active{
        color: #000;
      }
      .el-tabs__active-bar{
        background-color: #000;
      }
    }
  }
  .inputGroup {
    /deep/.el-input__inner {
      border-top-left-radius: 30px;
      border-bottom-left-radius: 30px;
    }
    /deep/.el-input-group__append {
      border-top-right-radius: 30px;
      border-bottom-right-radius: 30px;
      background-color: rgba(153, 196, 28, 0.2);
    }
  }
}

.flash-sale {
  max-width: 1400px;
  padding: 0 15px;
  position: relative;
  margin: 0 auto;
  h3 {
    font-family: 'Poppins';
    font-weight: 500;
    font-size: 20px;
    line-height: 30px;
    text-align: center;
    color: #000000;
  }
}
.product-item {
  width: 19%;
  margin: 0 0.5%;
}
.product-filter {
  margin-bottom: 15px;
  .shipping-from {
    margin-left: 20px;
    /deep/ .el-select__tags-text{
      max-width: 66px;
    }
  }
}
.empty {
  padding: 20px;
  p {
    margin-top: 20px;
  }
}
i {
  font-size: 20px;
  font-weight: 500;
}
.flash-sale-nav {
  max-width: 1400px;
  padding: 26px 0 6px 0;
  h2 {
    font-weight: 600;
    font-size: 30px;
    line-height: 45px;
    text-align: center;
    color: #ffffff;
    text-align: center;
  }
}
.more {
  width: 152px;
  height: 42px;
  border-radius: 42px;
  border: 1px solid #cdd4dd;
  font-size: 16px;
  margin: 10px auto;
  background-color: #fff;

  display: flex;

  /deep/ span {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  i {
    color: #8b93a3;
    margin-left: 10px;
  }
}
.mobile-flash {
  h3 {
    text-align: center;
  }
  background: #fff;
  padding: 0.2rem 0.3rem;
  .product-item {
    width: 48%;
    margin-bottom: 0.08rem;
  }
  .empty {
    padding: 20px;
    img {
      width: 60%;
    }
    p {
      margin-top: 20px;
    }
  }
  /deep/ .time-comp {
    .block {
      width: .4rem;
      height: .48rem;
      font-size: .3rem;
      line-height: .48rem;
    }
  }

  .sellTab{
    padding: 0px 0 1px 0;
    margin-bottom: 10px;
  }
}
/deep/.van-dropdown-menu__bar{
  box-shadow: none;
}
/deep/ .van-dropdown-item__option--active {
    color: #99C41C;
   background: rgba(153, 196, 28, 0.04);
}
/deep/.van-dropdown-item__icon{
  color: #99C41C;
}

/deep/.van-dropdown-menu__title--active {
   color: #99C41C;
}
/deep/.van-cell .van-cell--center{
  color: #99C41C;
}

/deep/.el-icon-check{
  color: #99C41C;
}
.checked-country{
  color: #99C41C;
   background: rgba(153, 196, 28, 0.04);
}
.fix-filter{
  width: 100%;
  // height: 40px;
  background: #fff;
  position: fixed;
  top: 0.85rem;
  left: 0;
  z-index: 10;
  padding:0 0.3rem;
}
</style>
